import { styled } from '@mui/material/styles';

const layoutVariantStyles = ({ theme, $layoutVariant, isRichText }) =>
  $layoutVariant === 'Layout Grid'
    ? `

     grid-template-columns: 100px 1fr;
     grid-template-rows: 1fr;
     ${theme.breakpoints.up('lg')} {
          grid-template-columns: 120px 1fr;
     }

    `
    : $layoutVariant === 'Layout Path'
    ? ` 
        display: block;

     ${theme.breakpoints.up('lg')} {
        grid-template-columns: 120px 1fr;
     }
    `
    : ` grid-template-columns: 130px;
        grid-template-rows: 130px 1fr;
        width: 100%;
        

   
   ${theme.breakpoints.up('lg')} {
     grid-template-columns: ${isRichText ? `140px` : `180px`};
     grid-template-rows:  ${isRichText ? `140px 1fr` : `180px 1fr`};
   }`;

export const StyledInlineGrid = styled('div')(
  ({ theme, $layoutVariant, isRichText }) => `
   display: grid;
   position: relative;
   justify-content: center;

    ${layoutVariantStyles({ theme, $layoutVariant, isRichText })};
`,
);

export const StyledIndexedCircle = styled('div')(
  ({ theme, setInMiddle }) => `
    width: ${theme.DS_spacing(['md'])};
    height: ${theme.DS_spacing(['md'])};
    position: absolute;
    top: ${setInMiddle ? `20%` : `${theme.DS_spacing(['xxxs'])}`};
    left: ${setInMiddle ? `50%` : `${theme.DS_spacing(['xxxs'])}`};
    z-index: 2;
    border: 2px solid ${theme.DS_palette.primary.black};
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.DS_palette.primary.white};
    
      ${theme.breakpoints.up('md')} {
       top: ${setInMiddle ? `28%` : `${theme.DS_spacing(['xxs'])}`};
      }
    
`,
);

const layoutVariantImageStyles = ({ theme, $layoutVariant, isRichText }) =>
  $layoutVariant === 'Layout Grid'
    ? `
     min-width: 100px;
     min-height: 100px;
     ${theme.breakpoints.up('lg')} {
        min-width: 120px;
        min-height: 120px;
      }

    `
    : $layoutVariant === 'Layout Path'
    ? `
     width: 100px;
     height: 100px;
     z-index: 2;
     position: relative;
     ${theme.breakpoints.up('md')} {
        min-width: 120px;
        min-height: 120px;
      }
  
     `
    : ` min-width: 120px;
        min-height: 120px;
        ${theme.breakpoints.up('lg')} {
        min-width: ${isRichText ? `120px` : `180px`};
        min-height: ${isRichText ? `120px` : `180px`};
   }
          
          `;

export const StyledImg = styled('img')(
  ({ $index, theme, $layoutVariant, isRichText }) => `
  object-fit: contain;
  aspect-ratio: 1 / 1;
  width: 100%;
  height: 100%;


   transition: all 0.2s linear;
   
   &.icon-pic {
      opacity: 0.2;
      scale:0;
   }
   &.icon-pic-drop-${$index} {
      opacity: 1;
      scale:1;
      transition-delay: 0.${$index}s;
   
   }

   ${layoutVariantImageStyles({ theme, $layoutVariant, isRichText })};
`,
);

export const StyledImageNumberContainer = styled('div')(
  () => `
  position:relative;
  justify-self: center;
  align-self: center;
  
`,
);

const layoutVariantTextStyles = ({ theme, $layoutVariant, isRichText }) =>
  $layoutVariant === 'Layout Grid'
    ? `  margin-left: ${theme.DS_spacing(['xs'])};
    `
    : $layoutVariant === 'Layout Stack' && isRichText
    ? `margin-top: ${theme.DS_spacing(['xxs'])};`
    : null;
export const StyledInfo = styled('div')(
  ({ theme, $layoutVariant, isRichText }) => `
  justify-self: start;
  align-self: start;
  height: 100%;
  ${layoutVariantTextStyles({ theme, $layoutVariant, isRichText })}
`,
);

export const StyledLine = styled('div')(
  ({ theme }) => `
   z-index: 1;
   
   height: 140px;
   width: calc(100% - 20px);
   
   ${theme.breakpoints.up('md')} {
     height: 120px;  
     width: calc(100% - 120px);
       
   }
    
   border: 4px solid black;
   position: absolute;
   top: 100%;
   left: 50%;
   transform: translate(-50%, -50%);
   transition: 1s ease 2s;
   
   &.line {
     opacity: 0;
   }
   
    &.line-draw{
     opacity: 1
   }
   

`,
);

export const StyledText = styled('div')(
  ({ theme }) => `

       width: 100%;
       position: absolute;
       top: 45%;
       hyphens: auto;

  
       ${theme.breakpoints.up('md')} {
          top: 55%;
          div {
            max-width: calc(100% - 280px);
            margin: 0 auto;   
          }  
       }
`,
);
